/**
 * Party entity index page
 */

import { EntityIndex } from './base';
import { canonicalPath } from '@electinfo/common';
import type { EntityConfig, EntitySearchResult } from './types';

class PartyIndex extends EntityIndex {
  getConfig(): EntityConfig {
    return {
      entityType: 'Party',
      placeholder: 'Search political parties...',
      browseTitle: 'All Parties',
      sortField: 'candidate_count',
      sortOrder: 'DESC',
      formatResult: (result: EntitySearchResult) => {
        const candidateCount = result.score ? Math.round(result.score) : 0;
        const countText = candidateCount === 1 ? '1 candidate' : `${candidateCount.toLocaleString()} candidates`;
        return {
          url: `/${canonicalPath('Party', result.id)}/`,
          name: result.name || '',
          meta: `${result.party || 'Political Party'} - ${countText}`
        };
      }
    };
  }
}

new PartyIndex();
